var _g, _ellipse, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_764_33138)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 33.5,
    ry: 31.5,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 29.3125,
    ry: 27.5625,
    fill: "#01537A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_33138)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5083 25.8423C30.3554 25.8423 26.9883 29.2088 26.9883 33.3623C26.9883 37.5152 30.3554 40.8817 34.5083 40.8817C38.6618 40.8817 42.0283 37.5152 42.0283 33.3623C42.0283 29.2088 38.6618 25.8423 34.5083 25.8423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5091 12.6821C31.3942 12.6821 28.8691 15.2072 28.8691 18.3221C28.8691 21.4371 31.3942 23.9621 34.5091 23.9621C37.6241 23.9621 40.1491 21.4371 40.1491 18.3221C40.1491 15.2072 37.6241 12.6821 34.5091 12.6821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2884 39.0015C19.1735 39.0015 16.6484 41.5265 16.6484 44.6415C16.6484 47.7564 19.1735 50.2815 22.2884 50.2815C25.4034 50.2815 27.9284 47.7564 27.9284 44.6415C27.9284 41.5265 25.4034 39.0015 22.2884 39.0015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7279 39.0015C43.6129 39.0015 41.0879 41.5265 41.0879 44.6415C41.0879 47.7564 43.6129 50.2815 46.7279 50.2815C49.8429 50.2815 52.3679 47.7564 52.3679 44.6415C52.3679 41.5265 49.8429 39.0015 46.7279 39.0015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5089 20.2021C35.5474 20.2021 36.3889 21.0436 36.3889 22.0821V27.7221C36.3889 28.7601 35.5474 29.6021 34.5089 29.6021C33.4704 29.6021 32.6289 28.7601 32.6289 27.7221V22.0821C32.6289 21.0436 33.4704 20.2021 34.5089 20.2021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7656 36.6187C38.4994 35.8843 39.6897 35.8843 40.4241 36.6187L44.4123 40.6063C45.1461 41.3407 45.1461 42.531 44.4123 43.2654C43.678 43.9991 42.4877 43.9991 41.7533 43.2654L37.7656 39.2771C37.0312 38.5427 37.0312 37.3524 37.7656 36.6187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2523 36.6187C30.518 35.8843 29.3277 35.8843 28.5933 36.6187L24.605 40.6063C23.8712 41.3407 23.8712 42.531 24.605 43.2654C25.3394 43.9991 26.5297 43.9991 27.2641 43.2654L31.2523 39.2771C31.9861 38.5427 31.9861 37.3524 31.2523 36.6187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_764_33138",
    x: 0,
    y: 0,
    width: 69,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_33138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_33138",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_33138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 37,
    fill: "white",
    transform: "translate(17 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons4);
export default __webpack_public_path__ + "static/media/Icons4.80c26cec15550c386d5225147ec376a6.svg";
export { ForwardRef as ReactComponent };